export const isEmailValid = (email: string) => {
  const trimmedEmail = email?.trim();
  return trimmedEmail && trimmedEmail.length > 0 && trimmedEmail.indexOf("@") !== -1 && trimmedEmail.indexOf(".") !== -1;
};
